import cn from 'classnames';
import React, { InputHTMLAttributes } from 'react';
import styles from './styles.module.css';

export type TextareaProps = InputHTMLAttributes<HTMLTextAreaElement> & {
    className?: string;
    inputClassName?: string;
    label?: string;
    placeholder?: string;
    name: string;
    error?: string;
    testId?: string;
};

const classes = {
    root: styles.root,
};

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    (
        {
            className = 'block',
            label,
            name,
            error,
            placeholder,
            inputClassName,
            testId,
            ...rest
        },
        ref
    ) => {
        const baseTestId = testId;
        const textareaTestId = baseTestId ? `${baseTestId}-input` : name;
        const labelTestId = baseTestId ? `${baseTestId}-label` : `textarea-label-${name}`;
        const errorTestId = baseTestId ? `${baseTestId}-error` : `textarea-error-${name}`;
        const rootClassName = cn(classes.root, inputClassName);

        return (
            <div className={className} data-testid={baseTestId ? `${baseTestId}-root` : `textarea-root-${name}`}>
                {label && (
                    <label
                        htmlFor={name}
                        data-testid={labelTestId}
                        className={styles.label}
                    >
                        {label}
                    </label>
                )}
                <textarea
                    data-testid={textareaTestId}
                    id={name}
                    name={name}
                    ref={ref}
                    placeholder={placeholder}
                    className={rootClassName}
                    autoComplete="off"
                    spellCheck="false"
                    {...rest}
                />
                {error && <p data-testid={errorTestId} className="my-2 text-xs text-red-500">{error}</p>}
            </div>
        );
    }
);

Textarea.displayName = 'Textarea';
